import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

/**
 * Slide-in drawer from the left for mobile sidebar.
 * Built on Radix Dialog so overlay + focus trap are handled for us.
 */
const MobileSidebarDrawer = ({ open, onClose, children }) => (
  <Dialog.Root open={open} onOpenChange={(o) => !o && onClose?.()}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in" />
      <Dialog.Content
        className="fixed left-0 top-0 z-50 h-full w-72 bg-white shadow-xl flex flex-col focus:outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left"
      >
        <div className="flex items-center justify-between px-3 py-3 border-b border-gray-200">
          <Dialog.Title className="text-sm font-semibold text-gray-900">
            Báo cáo
          </Dialog.Title>
          <Dialog.Close asChild>
            <button
              className="p-1.5 rounded hover:bg-gray-100 text-gray-500"
              aria-label="Đóng"
            >
              <X size={16} />
            </button>
          </Dialog.Close>
        </div>
        <div className="flex-1 overflow-y-auto">{children}</div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);

export default MobileSidebarDrawer;
